import { render, staticRenderFns } from "./DeactivationConfirmationPopup.vue?vue&type=template&id=5de2059a&scoped=true&"
import script from "./DeactivationConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./DeactivationConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeactivationConfirmationPopup.vue?vue&type=style&index=0&id=5de2059a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de2059a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de2059a')) {
      api.createRecord('5de2059a', component.options)
    } else {
      api.reload('5de2059a', component.options)
    }
    module.hot.accept("./DeactivationConfirmationPopup.vue?vue&type=template&id=5de2059a&scoped=true&", function () {
      api.rerender('5de2059a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/Deactivation/DeactivationConfirmationPopup.vue"
export default component.exports